export class WholeNumberSerializableValue {
  value?: number;

  constructor(value?: number) {
    this.value = value;
  }
}
